import React from 'react';
import { Consultant } from './index';
import { StarIcon, MapPinIcon, ClockIcon, CheckIcon, MonitorIcon, UsersIcon } from 'lucide-react';
interface ConsultantCardProps {
  consultant: Consultant;
  onBooking: () => void;
}
export function ConsultantCard({
  consultant,
  onBooking
}: ConsultantCardProps) {
  return <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-1479">
      <div className="p-5" data-id="element-1480">
        <div className="flex items-start" data-id="element-1481">
          <div className="w-20 h-20 rounded-full overflow-hidden border-2 border-sky-100 flex-shrink-0" data-id="element-1482">
            <img src={consultant.image} alt={consultant.name} className="w-full h-full object-cover" data-id="element-1483" />
          </div>
          <div className="mr-4 flex-1" data-id="element-1484">
            <div className="flex items-start justify-between" data-id="element-1485">
              <div data-id="element-1486">
                <h3 className="font-bold text-lg text-sky-900" data-id="element-1487">
                  {consultant.name}
                </h3>
                <p className="text-slate-600 text-sm" data-id="element-1488">{consultant.title}</p>
              </div>
              <div className="flex items-center bg-amber-50 px-2 py-1 rounded-md" data-id="element-1489">
                <StarIcon className="h-4 w-4 text-amber-500 ml-1" data-id="element-1490" />
                <span className="font-medium text-amber-700" data-id="element-1491">
                  {consultant.rating}
                </span>
                <span className="text-xs text-slate-500 mr-1" data-id="element-1492">
                  ({consultant.reviewCount})
                </span>
              </div>
            </div>
            <div className="mt-2 flex flex-wrap gap-1" data-id="element-1493">
              {consultant.specialization.map((spec, index) => <span key={index} className="text-xs bg-blue-50 text-blue-700 rounded-full px-2 py-0.5" data-id="element-1494">
                  {spec}
                </span>)}
            </div>
          </div>
        </div>
        <div className="mt-4 text-sm text-slate-700" data-id="element-1495">
          <div className="flex items-center text-slate-600 mb-2" data-id="element-1496">
            <CheckIcon className="h-4 w-4 text-green-500 ml-1" data-id="element-1497" />
            <span data-id="element-1498">{consultant.experience}</span>
          </div>
          <p className="mb-3" data-id="element-1499">{consultant.bio}</p>
          <div className="flex items-start mb-2" data-id="element-1500">
            <MapPinIcon className="h-4 w-4 text-slate-400 ml-1 mt-0.5 flex-shrink-0" data-id="element-1501" />
            <span className="text-slate-600" data-id="element-1502">{consultant.location}</span>
          </div>
          <div className="flex items-center mb-2" data-id="element-1503">
            <ClockIcon className="h-4 w-4 text-slate-400 ml-1" data-id="element-1504" />
            <span className="text-slate-600" data-id="element-1505">
              مدة الجلسة: {consultant.duration}
            </span>
          </div>
        </div>
        <div className="mt-4 space-y-2" data-id="element-1506">
          {consultant.onlineAvailable && <div className="flex items-center justify-between bg-green-50 p-2 rounded-md" data-id="element-1507">
              <div className="flex items-center" data-id="element-1508">
                <MonitorIcon className="h-4 w-4 text-green-600 ml-2" data-id="element-1509" />
                <span className="text-green-800 font-medium" data-id="element-1510">
                  استشارة أونلاين
                </span>
              </div>
              <span className="font-bold text-green-700" data-id="element-1511">
                {consultant.price.online}
              </span>
            </div>}
          {consultant.inPersonAvailable && <div className="flex items-center justify-between bg-purple-50 p-2 rounded-md" data-id="element-1512">
              <div className="flex items-center" data-id="element-1513">
                <UsersIcon className="h-4 w-4 text-purple-600 ml-2" data-id="element-1514" />
                <span className="text-purple-800 font-medium" data-id="element-1515">
                  استشارة وجاهية
                </span>
              </div>
              <span className="font-bold text-purple-700" data-id="element-1516">
                {consultant.price.inPerson}
              </span>
            </div>}
        </div>
        {consultant.badges && consultant.badges.length > 0 && <div className="mt-3 flex flex-wrap gap-1" data-id="element-1517">
            {consultant.badges.map((badge, index) => <span key={index} className="text-xs bg-rose-50 text-rose-700 rounded-full px-2 py-0.5" data-id="element-1518">
                {badge}
              </span>)}
          </div>}
        {consultant.discount && <div className="mt-3 bg-amber-50 border border-amber-100 rounded-md p-2 text-sm text-amber-800" data-id="element-1519">
            <span className="font-medium" data-id="element-1520">{consultant.discount}</span>
          </div>}
      </div>
      <div className="px-5 pb-5" data-id="element-1521">
        <button onClick={onBooking} className="w-full py-2.5 bg-sky-600 hover:bg-sky-700 text-white rounded-md transition-colors duration-200 font-medium" data-id="element-1522">
          حجز موعد
        </button>
      </div>
    </div>;
}